module.exports = __webpack_public_path__ + "static/img/vr-btn-share.53a81905.png";